export enum SectionItemOverflowStatus {
  NotSet,
  Included,
  Overflow
}
